import { useEffect } from "react";

import { useIntl } from "react-intl";

import { BannerProps } from "@/components/wpl/banner-alert/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { getBannerConfig } from "@/templates/paid-landing/utils/itsm-jsm-banner-alert";
import {
    AnchorContentsResponse,
    PaidLandingPersonaTypes
} from "@/utils/anchor-queries/get-anchor-contents";
import { experiments, useExperimentExposure } from "@/utils/experiment";

import { JiraSoftwarePagePaidLpJsmAnchor } from "./paid-lp-jsm-anchor";
export interface JiraSoftwarePagePaidLpJsmTicketingProps {
    anchorContents?: AnchorContentsResponse | null;
    bannerAlertProps?: BannerProps;
    persona?: string;
}

export const JiraServiceManagementSoftwarePagePaidLpJsmTicketing = (
    pageProps: JiraSoftwarePagePaidLpJsmTicketingProps
) => {
    const intl = useIntl();
    const linkUrl = useLocalizedHref(
        "/software/jira/service-management/comparison"
    );
    const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
        useExperimentExposure(experiments.cpapiDeprecationJsmExperiment);

    useEffect(() => {
        if (!cpapiDeprecationExposureFired) {
            fireCpapiDeprecationExposure();
        }
    }, [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure]);

    pageProps = Object.assign({}, pageProps, {
        bannerAlertProps: getBannerConfig({
            intl,
            linkUrl
        })
    });

    return (
        <JiraSoftwarePagePaidLpJsmAnchor
            {...pageProps}
            pageId="paid-lp-jsm-ticketing"
            persona={"unknown" as PaidLandingPersonaTypes}
            pageVariant="ticketing"
        />
    );
};
